<div class="card rounded-xl flex flex-col gap-2 overflow-hidden @container sm:max-w-64" [ngClass]="height">
  <div class="w-full aspect-[3/4] rounded-xl overflow-hidden">
    <a [routerLink]="directToPath()">
      <img [src]="getImagePath()" [alt]="getTitle()"
        class="w-full h-full object-center hover:scale-110 transition-transform duration-300" />
    </a>
  </div>

  <!-- Title and price with rating icon -->
  <div class="px-0.5 flex flex-col">
    <!-- Title with rating icon -->
    <div class="flex justify-between items-center mb-1">
      <h2 class="text-lg font-bold truncate flex-1" [ngClass]="color">{{ getTitle() }}</h2>
    </div>
    <div class="flex justify-between items-center mb-2">
      <!-- Price -->
      <p class="font-semibold text-base-content" [ngClass]="color" >EGP {{ mediaItem.price.toFixed(1) }}</p>
      <!-- popularity and star icon -->
      <div class="flex items-center">
        <span class="text-warning mr-1">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 20 20">
            <path
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        </span>
        <span class="text-primary font-semibold">{{(mediaItem.popularity%10)
          <5?((mediaItem.popularity%10)+5).toFixed(1):(mediaItem.popularity%10).toFixed(1)}}
        </span>
      </div>
    </div>

    <!-- Buttons - positioned at the bottom with -->
    <div class="flex justify-between gap-2 ">
      <button class="btn  btn-circle btn-secondary" (click)="addToWatchList()">
        @if (isInWatchList()) {
        <ng-icon name="faSolidBookmark" />
        }@else {
        <ng-icon name="faBookmark" />
        }
      </button>
      <button class="btn  flex-1 btn-primary " (click)="addToCart()">
        <ng-icon name="faSolidCartShopping" class="text-white" />
        {{ isInCart() ? 'Remove' : 'Add to Cart' }}
      </button>
    </div>
  </div>
</div>
